import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Popover,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Divider,
  Link,
} from '@mui/material';
import { Settings } from '@mui/icons-material';
import useMotivoBasicGate from '../useMotivoBasicGate';

export default function DemoControlPanel() {
  const { mode, showCTA, vetting, resources, supervisorsAdded, setToggle, resetDemoState } =
    useMotivoBasicGate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          width: 32,
          height: 32,
          backgroundColor: 'rgba(0, 0, 0, 0.15)',
          color: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1300,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <Settings sx={{ fontSize: 16 }} />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { p: 2.5, width: 280 } },
        }}
      >
        <Typography variant="body2" fontWeight="bold" mb={2}>
          Demo Controls
        </Typography>

        <Box display="flex" flexDirection="column" gap={1.5}>
          <Box>
            <Typography variant="body2" color="text.secondary" mb={0.5}>
              Mode
            </Typography>
            <ToggleButtonGroup
              value={mode}
              exclusive
              onChange={(_, val) => val && setToggle('mode', val)}
              size="small"
              fullWidth
            >
              <ToggleButton value="b2b" sx={{ textTransform: 'none', fontSize: '0.8rem' }}>
                B2B Origin
              </ToggleButton>
              <ToggleButton value="motivo-basic" sx={{ textTransform: 'none', fontSize: '0.8rem' }}>
                Motivo Basic Origin
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">Show CTA</Typography>
            <Switch
              size="small"
              checked={showCTA}
              onChange={(_, checked) => setToggle('showCTA', checked)}
            />
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">Vetting</Typography>
            <Switch
              size="small"
              checked={vetting}
              onChange={(_, checked) => setToggle('vetting', checked)}
            />
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">Resources</Typography>
            <Switch
              size="small"
              checked={resources}
              onChange={(_, checked) => setToggle('resources', checked)}
            />
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">Supervisors added</Typography>
            <Switch
              size="small"
              checked={supervisorsAdded}
              onChange={(_, checked) => setToggle('supervisorsAdded', checked)}
            />
          </Box>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Link
          component="button"
          variant="body2"
          onClick={() => {
            resetDemoState();
            setAnchorEl(null);
          }}
          sx={{ cursor: 'pointer' }}
        >
          Reset to defaults
        </Link>
      </Popover>
    </>
  );
}
